import i18next from 'i18next'

export const languages = ['en']

i18next.init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: {
      translations: require('./locales/en/translation.json'),
      faq: require('./locales/en/faq.json'),
      navigation: require('./locales/en/navigation.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
  returnObjects: true,
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  react: {
    wait: true,
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  },
})

i18next.languages = ['en']

export default i18next
